import { Model as ORMModel, attr, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'

export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),
      image: attr({ getDefault: () => '' }),
      matColorOne: attr({ getDefault: () => '#443d4f' }),
      matColorTwo: attr({ getDefault: () => '#3e3746' }),
      matBorderColor: attr({ getDefault: () => '#474156' }),
      ringRadiusColor: attr({ getDefault: () => '#a795bb' }),
      ringCenterColor: attr({ getDefault: () => '#b6a6b3' }),
      turnbuckleColor: attr({ getDefault: () => '#000' }),
      ropeColor: attr({ getDefault: () => '#201e3b' }),
      turnbuckleSize: attr({ getDefault: () => 10 }),
      ropeWidth: attr({ getDefault: () => 6 }),
      matBorderWidth: attr({ getDefault: () => 4 }),
      matLength: attr({ getDefault: () => 40 }),
      matDepth: attr({ getDefault: () => 80 }),
      table: attr({ getDefault: () => false }),
      tableBorderWidth: attr({ getDefault: () => 4 }),
      tableLength: attr({ getDefault: () => 80 }),
      tableDepth: attr({ getDefault: () => 40 }),
      ringRadius: attr({ getDefault: () => 20 }),
      showId: fk({
        to: 'Show',
        as: 'show',
        relatedName: 'ArenaShow'
      }),
    }
  }
  static reducer(action, Arena, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_ARENAS:
        session.Arena.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_ARENAS:
        action?.payload?.forEach(newItem => {
          session.Arena.upsert(newItem)
        })
        break
      case Types.ADD_ARENA:
        const id = action?.payload?.id || getId()
        Arena.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_ARENA:
        item = Arena.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_ARENA:
        Arena.withId(action.payload.id).delete()
        break
    }
  }
}
